const RouteView = {
  name: "RouteView",
  render: (h) => h("router-view"),
};

const layoutComponentMap = {
  "layouts/RouteView": RouteView,
  "layouts/BlankLayout": RouteView,
  "layouts/PageView": RouteView,
  "layouts/TabLayout": RouteView,
  "layouts/UserLayout": RouteView,
};

const componentAliasMap = {
  "dashboard/Analysis": "views/Home/Home",
  "dashboard/Workplace": "views/Home/Home",
};

function normalizeComponentPath(component) {
  if (!component) {
    return "";
  }
  let path = component.replace(/^\@\//, "");
  if (path.startsWith("/")) {
    path = path.slice(1);
  }
  if (path.endsWith(".vue")) {
    path = path.slice(0, -4);
  }
  return path;
}

function resolveComponent(component) {
  if (layoutComponentMap[component]) {
    return layoutComponentMap[component];
  }
  let viewPath = normalizeComponentPath(component);
  if (!viewPath) {
    return RouteView;
  }
  if (componentAliasMap[viewPath]) {
    viewPath = componentAliasMap[viewPath];
  }
  if (!viewPath.startsWith("views/") && !viewPath.startsWith("components/")) {
    viewPath = `views/${viewPath}`;
  }
  return (resolve) => require([`@/${viewPath}.vue`], resolve);
}

function transformRoute(node) {
  if (!node || node.route === "0") {
    return null;
  }
  const rawMeta = node.meta ? { ...node.meta } : {};
  const baseMeta = {
    alive: true,
    isFooter: false,
    isScrollTop: false,
    isCheckToken: true,
  };
  const route = {
    path: node.path,
    name: node.name || node.path.replace(/\//g, "_") || undefined,
    meta: { ...baseMeta, ...rawMeta },
  };
  const homeTitles = ["首页", "Home", "home"];
  const homePaths = ["/", "/dashboard/analysis", "/dashboard/workplace"];
  if (homePaths.includes(route.path) || homeTitles.includes(route.meta.title)) {
    route.meta.alive = false;
  }
  if (node.redirect) {
    route.redirect = node.redirect;
  }
  if (node.hidden) {
    route.hidden = true;
  }
  if (node.alwaysShow) {
    route.alwaysShow = true;
  }
  route.component = resolveComponent(node.component);
  if (Array.isArray(node.children) && node.children.length) {
    const children = node.children
      .map((child) => transformRoute(child))
      .filter((child) => child);
    if (children.length) {
      route.children = children;
    }
  }
  return route;
}

export function buildDynamicRoutes(menuTree = []) {
  const routes = menuTree
    .map((item) => transformRoute(item))
    .filter((item) => item);
  return routes;
}

function collectVisibleMenus(nodes = [], bucket = []) {
  nodes.forEach((node) => {
    if (!node || node.hidden || node.route === "0") {
      return;
    }
    const component = node.component || "";
    const hasChildren = Array.isArray(node.children) && node.children.length;
    const isLayout = layoutComponentMap[component] || component.includes("layouts/");
    if (hasChildren && isLayout) {
      collectVisibleMenus(node.children, bucket);
      return;
    }
    const title = (node.meta && node.meta.title) || node.title || node.name || "";
    if (!title) {
      return;
    }
    bucket.push({
      path: node.path,
      name: title,
      meta: node.meta ? { ...node.meta } : {},
    });
  });
  return bucket;
}

export function extractVisibleMenus(menuTree = []) {
  return collectVisibleMenus(menuTree, []);
}
